import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Article } from '@mui/icons-material';
import NotificationRowContent from 'components/notifications/NotificationRowContent';

/**
 * Fila de la campanita para las noticias. Sirve tanto para una noticia NUEVA como para una que se
 * actualizó: solo cambia el encabezado, porque el cuerpo (el titular) y el destino son los mismos.
 * Tener dos componentes idénticos salvo una cadena solo garantiza que uno se quede atrás.
 */
function NewsCreatedNotification({ notification }) {
  const { t } = useTranslation(['notifications']);
  const { title } = notification.data;

  const isUpdate = notification.data?.type === 'news.updated' || notification.type === 'news.updated';

  return (
    <NotificationRowContent
      notification={notification}
      icon={Article}
      title={
        isUpdate
          ? t('news.updatedTitle', { ns: 'notifications', defaultValue: 'Noticia actualizada' })
          : t('news.title', { ns: 'notifications' })
      }
      body={title}
    />
  );
}

NewsCreatedNotification.propTypes = {
  notification: PropTypes.shape({
    created_at: PropTypes.string.isRequired,
    data: PropTypes.shape({
      news_id: PropTypes.number,
      title: PropTypes.string.isRequired,
      type: PropTypes.string
    }).isRequired,
    id: PropTypes.string.isRequired,
    read: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired
  }).isRequired
};

export default NewsCreatedNotification;
